import { type CreateBlockData } from '@/lib/builder/types'

import {
  type ContentSectionCreate,
  type ContentSection,
} from '../../../WebsiteBuilder.types'

export const createContentData = ({
  brandId,
}: CreateBlockData<ContentSection>): ContentSectionCreate => ({
  brandId,
  params: {
    // Seed no CTA, heading, or body copy so an unedited block can never publish
    // placeholder content the merchant didn't write. The editor labels each
    // field, so empty inputs still guide them. The image is a real default, not
    // placeholder text, so it stays.
    action: null,
    alignment: 'left',
    background: null,
    body: null,
    foreground: {
      params: {
        image:
          'https://static-content.owner.com/309e231a-8c34-45ab-bcf8-e2fc40488472',
      },
      type: 'image',
    },
    header: null,
    layout: 'generic',
    media: {
      params: {
        image:
          'https://static-content.owner.com/309e231a-8c34-45ab-bcf8-e2fc40488472',
      },
      type: 'image',
    },
  },
  type: 'content',
})
